import { Component, inject } from '@angular/core';
import { IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { ReactiveFormsModule } from '@angular/forms';
import { getVerifyOtpV2DtoFormGroup, WorkAuthenticationV2Service, WorkVerifyOtpV2Dto } from '@work-frontend-monorepo/work-rest-api';
import { lastValueFrom } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { InputFieldComponent } from '@work-frontend-monorepo/work-ui/forms';
import { ButtonComponent, LogoComponent } from '@work-frontend-monorepo/work-ui/layout';
import { ExceptionHandlingService } from '@work-frontend-monorepo/work-ui/services';
import { ProfileStateSetProfile } from '@work-frontend-monorepo/work-ui/state-management';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'sfg-app-auth-verify-otp-page',
  templateUrl: './auth-verify-otp-page.component.html',
  styleUrls: ['./auth-verify-otp-page.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    InputFieldComponent,
    ButtonComponent,
    ReactiveFormsModule,
    InputFieldComponent,
    ButtonComponent,
    InputFieldComponent,
    LogoComponent,
    InputFieldComponent,
    IonHeader,
    IonTitle,
    IonToolbar,
    TranslatePipe,
  ],
})
export class AuthVerifyOtpPageComponent {
  private readonly exceptionHandlingService = inject(ExceptionHandlingService);
  private readonly workAuthenticationV2Service = inject(WorkAuthenticationV2Service);
  private readonly router = inject(Router);
  private readonly store = inject(Store);
  private readonly activatedRoute = inject(ActivatedRoute);

  protected formGroup = getVerifyOtpV2DtoFormGroup();

  constructor() {
    this.initializeMobileNumberFromQueryParams();
    console.log(this.formGroup.value);
  }

  protected async verifyOtp() {
    this.transformOtpFromNumberToString();
    try {
      await lastValueFrom(
        this.workAuthenticationV2Service.authenticationV2ControllerVerifyOtp({
          body: this.formGroup.value as WorkVerifyOtpV2Dto,
        }),
      );
      await this.loadProfileAndRedirect();
    } catch (verifyOtpFailedException) {
      this.exceptionHandlingService.handleExceptionWithAlert('verifyOtpFailedException', verifyOtpFailedException);
    }
  }

  private transformOtpFromNumberToString() {
    this.formGroup.patchValue({ otp: `${this.formGroup.value.otp}` });
  }

  private initializeMobileNumberFromQueryParams() {
    const mobileNumber = this.activatedRoute.snapshot.queryParams['mobilenumber'];
    if (mobileNumber) {
      this.formGroup.patchValue({ mobileNumber: decodeURIComponent(mobileNumber) });
    }
  }

  private async loadProfileAndRedirect(): Promise<void> {
    try {
      const profile = await lastValueFrom(this.workAuthenticationV2Service.authenticationV2ControllerProfile());
      this.store.dispatch(new ProfileStateSetProfile(profile));
      await this.router.navigateByUrl('/mitarbeitende/home');
    } catch (getProfileException) {
      this.exceptionHandlingService.handleExceptionWithAlert('getProfileException', getProfileException);
    }
  }
}
